'use client'

import React from 'react'
import { cn } from '@/utilities/ui'
import { quicksand } from '@/utilities/fontImport'

const COUNTRIES = [
  { value: 'be', label: 'Belgique' },
  { value: 'fr', label: 'France' },
]

interface SimpleCountrySelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
}

const SimpleCountrySelect = ({
  label,
  name,
  required,
  className,
  ...props
}: SimpleCountrySelectProps) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label className={cn('font-bold text-primary pl-1 text-sm', quicksand.className)}>
          {label}
        </label>
      )}
      <div className="gradient-border rounded-full">
        <select
          name={name}
          required={required}
          className="w-full rounded-full border-0 bg-pink-200 px-4 py-2.5 font-semibold text-primary outline-none focus-visible:ring-secondary/50"
          {...props}
        >
          <option value="">Sélectionnez un pays</option>
          {COUNTRIES.map((country) => (
            <option key={country.value} value={country.value}>
              {country.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default SimpleCountrySelect
